var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCou3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2076 15.6328L29.4576 5.63284C29.3696 5.53216 29.261 5.45149 29.1392 5.39624C29.0174 5.34099 28.8852 5.31245 28.7514 5.31253H11.2514C11.1182 5.31147 10.9864 5.33879 10.8646 5.39268C10.7428 5.44656 10.6339 5.52577 10.5451 5.62503L1.79514 15.625C1.64418 15.7994 1.56278 16.0233 1.56653 16.2539C1.57028 16.4845 1.6589 16.7057 1.81546 16.875L19.3155 35.625C19.4032 35.7192 19.5094 35.7943 19.6274 35.8456C19.7454 35.897 19.8727 35.9235 20.0014 35.9235C20.1301 35.9235 20.2574 35.897 20.3754 35.8456C20.4934 35.7943 20.5996 35.7192 20.6873 35.625L38.1873 16.875C38.3417 16.7061 38.429 16.4866 38.4328 16.2578C38.4365 16.029 38.3564 15.8067 38.2076 15.6328ZM11.867 17.1875L17.2733 30.7016L4.65921 17.1875H11.867ZM26.117 17.1875L20.0014 32.475L13.8858 17.1875H26.117ZM14.3764 15.3125L20.0014 7.81253L25.6264 15.3125H14.3764ZM28.1358 17.1875H35.3436L22.7295 30.7016L28.1358 17.1875ZM35.4358 15.3125H27.9701L21.8764 7.18753H28.3264L35.4358 15.3125ZM11.6764 7.18753H18.1264L12.0326 15.3125H4.56702L11.6764 7.18753Z",
    fill: "#E7EEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCou3);
export default __webpack_public_path__ + "static/media/cou3.955a9d3b43272ebdaafdc068f3f779ca.svg";
export { ForwardRef as ReactComponent };